import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';
const HomeCasaCeilo = () => {

    const [value, setValue] = useState(0);

    const images = [
        "/home_images/Casa-Ceilo/00.jpeg",
        "/home_images/Casa-Ceilo/01.jpeg",
        "/home_images/Casa-Ceilo/02.jpeg",
        "/home_images/Casa-Ceilo/03.jpeg",
        "/home_images/Casa-Ceilo/04.jpeg",
        "/home_images/Casa-Ceilo/05.jpeg",
        "/home_images/Casa-Ceilo/06.jpeg",
        "/home_images/Casa-Ceilo/07.jpeg",
        "/home_images/Casa-Ceilo/08.jpeg",
        "/home_images/Casa-Ceilo/09.jpeg",
        "/home_images/Casa-Ceilo/10.jpeg",
        "/home_images/Casa-Ceilo/11.jpeg",
        "/home_images/Casa-Ceilo/12.jpeg",
        "/home_images/Casa-Ceilo/13.jpeg",
        "/home_images/Casa-Ceilo/14.jpeg",
        "/home_images/Casa-Ceilo/15.jpeg",
        "/home_images/Casa-Ceilo/16.jpeg",
        "/home_images/Casa-Ceilo/17.jpeg",
        "/home_images/Casa-Ceilo/18.jpeg",
        "/home_images/Casa-Ceilo/19.jpeg",
        "/home_images/Casa-Ceilo/20.jpeg",
        "/home_images/Casa-Ceilo/21.jpeg",
        "/home_images/Casa-Ceilo/22.jpeg",
        "/home_images/Casa-Ceilo/23.jpeg",
        "/home_images/Casa-Ceilo/24.jpeg",
        "/home_images/Casa-Ceilo/25.jpeg",
        "/home_images/Casa-Ceilo/26.jpeg",
        "/home_images/Casa-Ceilo/27.jpeg",
        "/home_images/Casa-Ceilo/28.jpeg",
        "/home_images/Casa-Ceilo/29.jpeg",
        "/home_images/Casa-Ceilo/30.jpeg",
        "/home_images/Casa-Ceilo/31.jpeg",
        "/home_images/Casa-Ceilo/32.jpeg",
        "/home_images/Casa-Ceilo/33.jpeg",
        "/home_images/Casa-Ceilo/34.jpeg",
        "/home_images/Casa-Ceilo/35.jpeg",
        "/home_images/Casa-Ceilo/36.jpeg",
        "/home_images/Casa-Ceilo/37.jpeg",
        "/home_images/Casa-Ceilo/38.jpeg",
        "/home_images/Casa-Ceilo/39.jpeg",
        "/home_images/Casa-Ceilo/40.jpeg",
        "/home_images/Casa-Ceilo/41.jpeg",
        "/home_images/Casa-Ceilo/42.jpeg",
        "/home_images/Casa-Ceilo/43.jpeg",
        "/home_images/Casa-Ceilo/44.jpeg",
        "/home_images/Casa-Ceilo/45.jpeg",
        "/home_images/Casa-Ceilo/46.jpeg",
        "/home_images/Casa-Ceilo/47.jpeg",
        "/home_images/Casa-Ceilo/48.jpeg",
        "/home_images/Casa-Ceilo/49.jpeg",
        "/home_images/Casa-Ceilo/50.jpeg",
        "/home_images/Casa-Ceilo/51.jpeg",
        "/home_images/Casa-Ceilo/52.jpeg",
        "/home_images/Casa-Ceilo/53.jpeg",
        "/home_images/Casa-Ceilo/54.jpeg",
        "/home_images/Casa-Ceilo/55.jpeg",
        "/home_images/Casa-Ceilo/56.jpeg",
        "/home_images/Casa-Ceilo/57.jpeg",
        "/home_images/Casa-Ceilo/58.jpeg",
        "/home_images/Casa-Ceilo/59.jpeg",
        "/home_images/Casa-Ceilo/60.jpeg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return (
        <div className="full-container">
            <img src={`/home_images/Casa-Ceilo/${String(value).padStart(2, "0")}.jpeg`} alt="" className="home_page_images rotate_view casa-ceilo" />
            <div className="home-slider-container">
                <Form.Range min={0} max={59} value={value}
                    onChange={(e) => setValue(e.target.value)} className="home_range_slider" />
            </div>
        </div>
    )
}

export default HomeCasaCeilo;